import { useState } from "react";

// helpers
import { addFeedback } from "../common/helper";

// components
import { Button } from "shared/components/bulma/button";
import { Modal, ModalContent, ModalControl } from "shared/components/bulma/modal";

const AddFeedbackModal = ({ isActive, onDismiss, onConfirm }) => {
    const [feedback, setFeedback] = useState('');

    const handleChange = async (event) => {
        const { value } = event.target;
        setFeedback(value);
    }

    const handleConfirm = () => {
        if (onConfirm) { onConfirm(feedback) };
    }

    const SubmitButton = () => {
        if (feedback.trim()) {
            return <Button onClick={handleConfirm} className="is-primary">Add</Button>
        }

        return null;
    }

    return (
        <Modal title="Add Feedback" isActive={isActive}>
            <ModalContent>
                <textarea className="textarea has-fixed-size" placeholder="Type to add feedback" onChange={handleChange}></textarea>
            </ModalContent>
            <ModalControl>
                <SubmitButton />
                <Button onClick={onDismiss}>Cancel</Button>
            </ModalControl>
        </Modal>
    );
}

const AddFeedback = ({ customer, box, onAdd }) => {
    const [isActive, setActive] = useState(false);

    const handleClick = async () => {
        setActive(true);
    }

    const dismiss = () => {
        setActive(false);
    }

    const add = async (feedback) => {
        setActive(false);

        await addFeedback({ customer, box, feedback })
        if (onAdd) { onAdd(feedback); }
    }

    if (box.extra_feedback) {
        return null;
    }

    const Modal = () => {
        if (!isActive) {
            return null;
        }

        return (
            <AddFeedbackModal isActive={true} onConfirm={add} onDismiss={dismiss} />
        );
    }

    return (
        <>
            <Button className="is-small is-dark is-outlined" onClick={handleClick} >
                <span className="icon">
                    <i className="fas fa-plus-square"></i>
                </span>
                <span>Add Feedback</span>
            </Button>

            <Modal />
        </>
    );
}

export { AddFeedback };
